import React from "react";

const Titulo = (props) => {
    const { atlas, data } = props;
    //Se crea array de entidades que contienen siglas que deben ir en mayúsculas. Bug UAAD17-1236
    let entidadSiglas = ['CATEGORIA_IVA', 'IIBB_CATEGORIA', 'TIPO_COMPROBANTE_IIBB'];

    let letraMayus = data.nombreEntidad.substring(1, 0);
    let descripcion = letraMayus + data.nombreEntidad.toLowerCase().substring(data.nombreEntidad.length, 1);

    //Se reemplazan las siglas que quedaron en minúsculas por mayúsculas. Bug UAAD17-1236
    if (entidadSiglas.includes(data.codigoEntidad)) {
        descripcion = descripcion.replace(/ iva| iibb/i, function(x) {return x.toUpperCase()});
    }

    descripcion = ((atlas.entidadInstanciaId) ? "Editar " : (data.generoEntidad ? "Nuevo " : "Nueva ")) + descripcion;

    return <div className="row bottom-separator-xs">
        <div className="col-xs-12">
            <h1>{descripcion}</h1>
        </div>
    </div>
}


export default Titulo